<template>
    <div class="field" style="padding-right: 15px;">
        <button class="button is-small is-info is-outlined" @click="openBidModal(bid.lot_id)">
            <img src="/static/images/icons/update-bid.png" class="update-bid-icon fontawesome-icon">
            <span>{{ bid.amount_yen * 1000 | formatNumber }}</span>
        </button>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
            return {

            }
        },
        methods: {
            openBidModal(lotId) {
                this.$store.dispatch('fetchGroups', {date: this.bid.date})
                this.$store.dispatch('fetchGroupSettings')
                this.$store.dispatch('changeCurrentBidLotId', lotId)
                this.$store.dispatch('changePlaceBidLoadingStatus', true)
                apiBids
                    .bidRequest(this.bid.id)
                    .then((response) => {
                        console.log(response.data)
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.$store.dispatch('changeCurrentBidId', response.data.id)
                        this.$store.dispatch('changeCurrentBidStatus', response.data.status)
                        this.$store.dispatch('changeCurrentBidGroup', response.data.group)
                        this.$store.dispatch('changeSelectedGroup', response.data.group)

                    })
                    .catch((err) => {
                        console.log(err.response)
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.$store.dispatch('changeBidError', {field: 'status', value: true})
                        this.$store.dispatch('changeBidError', {field: 'message', value: err.response.data.bid})
                    })
                this.$store.dispatch('changeBidModalStatus', { status: true, lotId: lotId })
            }
        },
        mounted () {

        }
    }

</script>

<style scoped>
    .button {
        font-weight: 700;
    }
    .button i {
        margin-right: 0.3em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Lots/BidUpdate.vue